import {
  Collapse,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import React, { useState } from 'react'

import { ChangeModal } from '../../../../components/ChangeModal'
import { getTranslate } from '../../../../localization'
import { Currency } from '../../../../types/currency'
import useStyles from './styles/index.styles'

type Option = {
  name: string
  id: string
  currency: Currency
  cashBalance: number
  remainingCreditBalance: number
}
type Props = {
  title: string
  options: Option[]
  selectedWalletType: {
    walletName: string
    walletID: string
  }
  setSelectedWalletType: React.Dispatch<
    React.SetStateAction<{
      walletName: string
      walletID: string
    }>
  >
}

const PaymentWallet = ({
  title,
  options,
  selectedWalletType,
  setSelectedWalletType
}: Props) => {
  const classes = useStyles()
  const [pendingOption, setPendingOption] = useState<Option | null>(null)
  const [showChangeWalletModal, setShowChangeWalletModal] = useState(false)
  return (
    <>
      <div className={classes.root}>
        <div className={classes.walletHeader}>
          <Typography variant="h5" className={classes.filterText}>
            {title}
          </Typography>
        </div>
        <Collapse in={!selectedWalletType.walletName && options.length > 0}>
          <div className={classes.warning}>
            <Typography variant="subtitle1" className={classes.verticalAlign}>
              <WarningIcon className={classes.icon} />
              {getTranslate('Warning')}
            </Typography>
            <Typography variant="h5" className={classes.text}>
              {getTranslate(
                'You have to choose one payment method to continue reservation'
              )}
            </Typography>
          </div>
        </Collapse>
        <div className={classes.options}>
          <RadioGroup value={selectedWalletType.walletName}>
            {options.map((opt, index) => (
              <div
                key={index}
                className={[
                  classes.options,
                  selectedWalletType.walletName === opt.name
                    ? classes.selectedOption
                    : ''
                ].join(' ')}>
                <FormControlLabel
                  key={index}
                  classes={{ label: classes.formLabel }}
                  className={classes.formControl}
                  value={opt.name}
                  control={
                    <Radio
                      classes={{ root: classes.radiobtn }}
                      size="small"
                      color="primary"
                      onChange={() => {
                        if (
                          selectedWalletType.walletName &&
                          selectedWalletType.walletName !== opt.name
                        ) {
                          setPendingOption(opt)
                          setShowChangeWalletModal(true)
                        } else {
                          setSelectedWalletType({
                            walletName: opt.name,
                            walletID: opt.id
                          })
                        }
                      }}
                    />
                  }
                  label={getTranslate(opt.name)}
                />
                <Collapse
                  in={selectedWalletType.walletName === opt.name}
                  timeout="auto"
                  unmountOnExit>
                  {opt.name === 'AdoPay' && (
                    <div className={classes.balanceContainer}>
                      <div className={classes.row}>
                        <Typography variant="h6" className={classes.text}>
                          {getTranslate('Cash Balance')}
                        </Typography>
                        <Typography variant="h6" className={classes.text}>
                          {`${opt.cashBalance} ${getTranslate(
                            opt.currency || ''
                          )}`}
                        </Typography>
                      </div>
                      <div className={classes.row}>
                        <Typography variant="h6" className={classes.text}>
                          {getTranslate('Credit Balance')}
                        </Typography>
                        <Typography variant="h6" className={classes.text}>
                          {`${opt.remainingCreditBalance} ${getTranslate(
                            opt.currency || ''
                          )}`}
                        </Typography>
                      </div>
                    </div>
                  )}
                </Collapse>
              </div>
            ))}
          </RadioGroup>
        </div>
      </div>
      <ChangeModal
        isOpen={showChangeWalletModal}
        onClick={() => {
          if (pendingOption) {
            setSelectedWalletType({
              walletName: pendingOption.name,
              walletID: pendingOption.id
            })
            setPendingOption(null)
          }
          setShowChangeWalletModal(false)
        }}
        changesFrom={selectedWalletType.walletName}
        changesTo={pendingOption?.name}
        onClose={() => setShowChangeWalletModal(false)}
      />
    </>
  )
}

export default PaymentWallet
